export default class DeviceBootConfigService {
  constructor(apiService) {
    this.apiService = apiService
  }

  getEntity(id, params) {
    return this.apiService.callGet('me/device_boot_configs/' + id, params)
  }

  getEntities(params) {
    return this.apiService.callGet('me/device_boot_configs', params)
  }

  createEntity(params) {
    return this.apiService.callPost('me/device_boot_configs', params)
  }

  updateEntity(id, params) {
    return this.apiService.callPut('me/device_boot_configs/' + id, params)
  }

  deleteEntity(id, params) {
    return this.apiService.callDelete('me/device_boot_configs/' + id, params)
  }
}



// WEBPACK FOOTER //
// ./src/service/DeviceBootConfigService.js